<!--
 * @Author: WLL
 * @Date: 2020-04-16 11:02:22
 * @LastEditors: WLL
 * @LastEditTime: 2020-04-18 23:08:25
 * @Description: Chart
 -->
<template>
  <div class="chart">
    <ECharts
      v-on="$listeners"
      :options="optionsFinal"
      autoresize
      v-if="!showBlank"
    ></ECharts>
    <SjBlank v-else />
  </div>
</template>

<script>
import ECharts from "vue-echarts";
/**
 * 引入使用的echart图表类型
 */
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/component/tooltip";

import merge from "lodash.merge";
import isequal from "lodash.isequal";

export default {
  name: "Chart",
  components: {
    ECharts
  },
  props: {
    options: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      defaultOptions: {
        grid: {
          show: true,
          containLabel: true,
          left: 0,
          top: 20,
          right: 20,
          bottom: 0,
          borderColor: "#e8e8e8",
          borderWidth: 1
        },
        tooltip: {
          trigger: "axis"
        },
        xAxis: {
          type: "category",
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            interval: 0,
            rotate: "45",
            color: "#97a3b4"
          },
          splitLine: {
            lineStyle: {
              color: ["#e3e3e3"],
              type: "dashed"
            }
          }
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: "#97a3b4"
          },
          splitNumber: 4,
          splitLine: {
            show: true,
            lineStyle: {
              color: ["#e3e3e3"],
              type: "dashed"
            }
          }
        }
      }
    };
  },
  computed: {
    optionsFinal() {
      const { options, defaultOptions } = this;
      return merge({}, defaultOptions, options);
    },
    showBlank() {
      const { options } = this;
      return isequal(options, {});
    }
  }
};
</script>

<style lang="less" scoped>
.chart {
  height: 100%;
  width: 100%;
  .echarts {
    height: 100%;
    width: 100%;
  }
}
</style>
